<template>
  <div v-if="list && list.length > 0" class="p-t-20 open">
    <div class="home-three-title">
      <div class="text">
        <img class="item-img" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/homeThree/hot.png">
        <slot>精品课程</slot>
      </div>
      <span class="more" @click="zhibokes">查看更多&nbsp;></span>
    </div>
    <div class="live-all">
      <div v-if="list && list.length > 0" class="live">
        <img class="bag" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/homeThree/bagOpen.png">
        <div v-for="(item, index) in list" :key="index" class="item" @click="goPage(item)">
          <div class="item-img"><img :src="item.surfacePlot"></div>
          <div class="detail">
            <div class="detail-title twoEllipsis">{{ item.courseName }}</div>
            <div class="item-tips elp">"{{ item.belongCollegeName }}<span> · </span> {{ item.belongProjectName }}"</div>
            <div class="flex-between-c price-box">
              <div class="price"><span class="price-icon">￥</span>{{ item.currentPrice }}</div>
              <div class="tips">人气值 {{ item.browseFrequency ? item.browseFrequency : 0 }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="list2 && list2.length > 0" class="live">
        <img class="bag" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/homeThree/bagOpen.png">
        <div v-for="(item, index) in list2" :key="index" class="item" @click="goPage(item)">
          <div class="item-img"><img :src="item.surfacePlot"></div>
          <div class="detail">
            <div class="detail-title twoEllipsis">{{ item.courseName }}</div>
            <div class="item-tips elp">"{{ item.belongCollegeName }}<span> · </span> {{ item.belongProjectName }}"</div>
            <div class="flex-between-c price-box">
              <div class="price"><span class="price-icon">￥</span>{{ item.currentPrice }}</div>
              <div class="tips">人气值 {{ item.browseFrequency ? item.browseFrequency : 0 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/common.css'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {},
  data() {
    return {
      list: [],
      list2: []
    }
  },
  created() {
    homeClient.qbsJxyCourse({pageNum: 1, pageSize: 6}).then((res) => {
      this.list = res.data.rows.filter((item, index) => {
        return index < 3
      })
      this.list2 = res.data.rows.filter((item, index) => {
        return index > 2
      })
    })
  },
  methods: {
    zhibokes() {
      const routeUrl = this.$router.resolve({
        path: '/jingpin/courer'
      })
      window.open(routeUrl.href, '_blank')
    },
    goPage(item) {
      if (!item) {
        return
      }
      if (item.teachingMethod == 1) {
        const routeUrl = this.$router.resolve({
          path: `/zhiboclassxq?id=${item.id}`
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.teachingMethod == 2) {
        const routeUrl = this.$router.resolve({
          path: `/videoxq?id=${item.id}`
        })
        window.open(routeUrl.href, '_blank')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.open {
  margin-bottom: 60px;
}

.home-three-title {
  width: 1220px !important;
  padding-bottom: 32px;
  padding-top: 0px;
}

.live-all {
  width: 1220px;
  display: flex;
  justify-content: space-between;
  margin: 0px auto;

  .live {
    width: 590px;
    height: 514px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    position: relative;
    padding: 32px;

    .bag {
      position: absolute;
      top: 0px;
      width: 100%;
      height: 60px;
      left: 0px;
    }

    .item {
      margin-bottom: 24px;
      width: 100%;
      height: 126px;
      background: #ffffff;
      overflow: hidden;
      cursor: pointer;
      display: flex;
      margin-bottom: 36px;

      .item-img {
        width: 224px;
        height: 126px;
        border-radius: 8px;
        overflow: hidden;
        opacity: 1;
        flex-shrink: 0;

        img {
          width: 100%;
        }
      }

      .detail {
        width: 100%;
        margin-left: 16px;

        .detail-title {
          height: 48px;
          font-size: 16px;
          line-height: 24px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }

        .item-tips {
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #ff7b1c;
          line-height: 12px;
          margin-top: 12px;
        }

        .tips {
          font-size: 14px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #999999;
          line-height: 14px;
        }

        .price-box {
          margin-top: 24px;
          width: 100%;
          align-items: flex-end;

          .price {
            font-family: Microsoft YaHei-Regular;
            color: #ff5d51;
            font-size: 24px;
            line-height: 24px;
            font-weight: Bold;

            .price-icon {
              font-size: 14px;
              line-height: 14px;
              font-weight: 400;
            }
          }
        }
      }
    }
  }
}
</style>
